<ion-content class="background">
  <div class="header-page">
    <app-header-not-buttons></app-header-not-buttons>

    <app-title-four title="Manejo de Datos Personales"></app-title-four>
  </div>

  <ion-grid class="form-data" *ngIf="country==='es_Ar'">
    <ion-row>
      <ion-col size="12">
        <section>
          <ion-label class="doc-content">
            En cumplimiento con las leyes de Protección de Datos Personales: Argentina: Ley 25.326; Chile: Ley 19.628 y 21.719 y nuestras políticas internas aplicables, le
            comunicamos que los datos que Usted nos entregue relacionados con el alcance del Programa de diagnóstico
            para la región del Cono Sur (el "Programa") quedarán incorporados en nuestras bases de datos, cuyos
            responsables del tratamiento es la empresa Tudo Bem Tudo Bom Andean SAS, (en adelante "TBTB").
            
            <section>
              <ion-label class="doc-content">
                Por medio de la aceptación del presente documento, Usted en calidad de titular estará autorizando de manera previa,
                expresa, libre e informada a TBTB y sus entidades vinculadas para que como Entidad que gestiona la aplicación,
                recolecte y dé tratamiento de sus datos personales tales como nombre completo, correo electrónico,
                direcciones, números telefónicos, profesión, especialidad y registro o matrícula profesional según
                corresponda.
              </ion-label>
            </section>
            
            <section>
              <ion-label class="doc-content">
                De igual manera, entiende que según el servicio o apoyo requerido a través del programa,
                especialmente aquellos relacionados con la solicitud de toma de muestras o realización de pruebas a
                pacientes para el diagnóstico o seguimiento de patologías específicas, deberá suministrar los datos
                personales o sensible que como mínimo sean requeridos para la gestión de los servicios solicitados a través
                del programa y que es su responsabilidad haber informado de manera previa al tercero, para que
                posteriormente sea contactado por TBTB o sus entidades vinculadas para la coordinación de dichos servicios.
                (tanto los datos sensibles como los no sensibles en adelante se denominarán los "Datos").
              </ion-label>
            </section>
            
            <section>
              <ion-label class="doc-content">
                Los Datos serán recolectados, almacenados, usados, compilados, intercambiados e incorporados en distintas bases de datos o
                en depósitos electrónicos con las siguientes finalidades:
              </ion-label>
            </section>
            
            <section>
              <ion-label class="doc-content">
                a) Gestionar las solicitudes de toma y análisis de pruebas diagnósticas, confirmatorias y/o de seguimiento a pacientes hechas por un médico especialista según criterio profesional;
              </ion-label>
            </section>
            
            <section>
              <ion-label class="doc-content">
                b) Compartir con proveedores y/o terceros autorizados, la información específica y necesaria para la coordinación y realización de la toma, transporte y análisis de las muestras;
              </ion-label>
            </section>
            
            <section>
              <ion-label class="doc-content">
                c) Remitirle los resultados de exámenes médicos;
              </ion-label>
            </section>
            
            <section>
              <ion-label class="doc-content">
                d) Gestionar el retiro de muestras y/o envío de materiales (kits de diagnóstico) para la toma de muestras.
              </ion-label>
            </section>
            
            <section>
              <ion-label class="doc-content">
                De igual manera le informamos que dichos servicios están siendo
                patrocinados por Sanofi-Aventis de Argentina S.A. y/o Sanofi-Aventis de Chile, S.A., quienes bajo ninguna circunstancia tendrán acceso a los Datos que usted decida
                suministrar a TBTB, único responsable del tratamiento. Sin embargo, TBTB podrá compartir con Sanofi-Aventis de Argentina S.A., Sanofi-Aventis de Chile, S.A. y cualquier afiliada de esta en Latinoamérica o Francia, información estadística anonimizada relacionada al Programa.
              </ion-label>
            </section>
            
            <section>
              <ion-label class="doc-content">
                Usted declara que la información personal que
                suministra es veraz, completa, exacta, actualizada, comprobable y comprensible y que ha sido informado de su
                derecho a negarse a responder preguntas de carácter sensible, así como de su derecho a conocer, rectificar,
                incluir, actualizar y solicitar la supresión de su información personal en cualquier momento y sin perjuicio
                alguno, enviando una solicitud al siguiente correo:
                <a target="_blank" href="mailto:contactenos&#64;tbtbglobal.com">contactenos&#64;tbtbglobal.com</a>.
              </ion-label>
            </section>
            
            <section>
              <ion-label class="doc-content">
                Igualmente ha sido informado de su derecho a elevar consultas o preguntas sobre los datos personales que
                están siendo tratados o interponer quejas que serán tratadas de acuerdo con el procedimiento establecido por
                las autoridades competentes de su país. También puede consultar la política de privacidad de datos de Tudo
                Bem Tudo Bom Andean SAS, disponible en el siguiente enlace
                <a target="_blank" href="https://tbtb.global/politicas-privacidad/">https://tbtb.global/politicas-privacidad/</a>
              </ion-label>
            </section>
            
            <section>
              <ion-label class="doc-content">
                Ley de Protección de los Datos Personales: Argentina: Ley 25.326; Chile: Ley 19.628 y 21.719.
              </ion-label>
            </section>
            
          </ion-label>
        </section>
      </ion-col> 
      <ion-col size="12" class="center" *ngIf="!id">
        <button (click)="closeModal()" shape="round" class="btn-primary btn-close">Cerrar</button>
      </ion-col>
      <ion-col class="ion-text-center" size="12" *ngIf="id">
        <button (click)="submit()" id="btn-edit-modal" class="btn-primary btn-close">Aceptar</button>
      </ion-col>
      <ion-col class="ion-text-center" size="12" *ngIf="id">
        <button (click)="openAlert()" id="btn-create-modal" class="btn-primary-2">Rechazar</button>
      </ion-col>
    </ion-row>
  </ion-grid>

  <ion-grid class="form-data" *ngIf="country==='es_Ch'">
    <ion-row>
      <ion-col size="12">
        <section>
          <ion-label class="doc-content">
            En cumplimiento con las leyes de Protección de Datos Personales: Argentina: Ley 25.326; Chile: Ley 19.628 y 21.719 y nuestras políticas internas aplicables, le
            comunicamos que los datos que Usted nos entregue relacionados con el alcance del Programa de diagnóstico
            para la región del Cono Sur (el "Programa") quedarán incorporados en nuestras bases de datos, cuyos
            responsables del tratamiento es la empresa Tudo Bem Tudo Bom Andean SAS, (en adelante "TBTB").
            
            <section>
              <ion-label class="doc-content">
                Por medio de la aceptación del presente documento, Usted en calidad de titular estará autorizando de manera previa,
                expresa, libre e informada a TBTB y sus entidades vinculadas para que como Entidad que gestiona la aplicación,
                recolecte y dé tratamiento de sus datos personales tales como nombre completo, correo electrónico,
                direcciones, números telefónicos, profesión, especialidad y registro o matrícula profesional según
                corresponda.
              </ion-label>
            </section>
            
            <section>
              <ion-label class="doc-content">
                De igual manera, entiende que según el servicio o apoyo requerido a través del programa,
                especialmente aquellos relacionados con la solicitud de toma de muestras o realización de pruebas a
                pacientes para el diagnóstico o seguimiento de patologías específicas, deberá suministrar los datos
                personales o sensible que como mínimo sean requeridos para la gestión de los servicios solicitados a través
                del programa y que es su responsabilidad haber informado de manera previa al tercero, para que
                posteriormente sea contactado por TBTB o sus entidades vinculadas para la coordinación de dichos servicios.
                (tanto los datos sensibles como los no sensibles en adelante se denominarán los "Datos").
              </ion-label>
            </section>
            
            <section>
              <ion-label class="doc-content">
                Los Datos serán recolectados, almacenados, usados, compilados, intercambiados e incorporados en distintas bases de datos o
                en depósitos electrónicos con las siguientes finalidades:
              </ion-label>
            </section>
            
            <section>
              <ion-label class="doc-content">
                a) Gestionar las solicitudes de toma y análisis de pruebas diagnósticas, confirmatorias y/o de seguimiento a pacientes hechas por un médico especialista según criterio profesional;
              </ion-label>
            </section>
            
            <section>
              <ion-label class="doc-content">
                b) Compartir con proveedores y/o terceros autorizados, la información específica y necesaria para la coordinación y realización de la toma, transporte y análisis de las muestras;
              </ion-label>
            </section>
            
            <section>
              <ion-label class="doc-content">
                c) Remitirle los resultados de exámenes médicos;
              </ion-label>
            </section>
            
            <section>
              <ion-label class="doc-content">
                d) Gestionar el retiro de muestras y/o envío de materiales (kits de diagnóstico) para la toma de muestras.
              </ion-label>
            </section>
            
            <section>
              <ion-label class="doc-content">
                De igual manera le informamos que dichos servicios están siendo
                patrocinados por Sanofi-Aventis de Argentina S.A. y/o Sanofi-Aventis de Chile, S.A., quienes bajo ninguna circunstancia tendrán acceso a los Datos que usted decida
                suministrar a TBTB, único responsable del tratamiento. Sin embargo, TBTB podrá compartir con Sanofi-Aventis de Argentina S.A., Sanofi-Aventis de Chile, S.A. y cualquier afiliada de esta en Latinoamérica o Francia, información estadística anonimizada relacionada al Programa.
              </ion-label>
            </section>
            
            <section>
              <ion-label class="doc-content">
                Usted declara que la información personal que
                suministra es veraz, completa, exacta, actualizada, comprobable y comprensible y que ha sido informado de su
                derecho a negarse a responder preguntas de carácter sensible, así como de su derecho a conocer, rectificar,
                incluir, actualizar y solicitar la supresión de su información personal en cualquier momento y sin perjuicio
                alguno, enviando una solicitud al siguiente correo:
                <a target="_blank" href="mailto:contactenos&#64;tbtbglobal.com">contactenos&#64;tbtbglobal.com</a>.
              </ion-label>
            </section>
            
            <section>
              <ion-label class="doc-content">
                Igualmente ha sido informado de su derecho a elevar consultas o preguntas sobre los datos personales que
                están siendo tratados o interponer quejas que serán tratadas de acuerdo con el procedimiento establecido por
                las autoridades competentes de su país. También puede consultar la política de privacidad de datos de Tudo
                Bem Tudo Bom Andean SAS, disponible en el siguiente enlace
                <a target="_blank" href="https://tbtb.global/politicas-privacidad/">https://tbtb.global/politicas-privacidad/</a>
              </ion-label>
            </section>
            
            <section>
              <ion-label class="doc-content">
                Ley de Protección de los Datos Personales: Argentina: Ley 25.326; Chile: Ley 19.628 y 21.719.
              </ion-label>
            </section>
            
          </ion-label>
        </section>
      </ion-col>
      <ion-col size="12" class="center" *ngIf="!id">
        <button (click)="closeModal()" shape="round" class="btn-primary btn-close">Cerrar</button>
      </ion-col>
      <ion-col class="ion-text-center" size="12" *ngIf="id">
        <button (click)="submit()" id="btn-edit-modal" class="btn-primary btn-close">Aceptar</button>
      </ion-col>
      <ion-col class="ion-text-center" size="12" *ngIf="id">
        <button (click)="openAlert()" id="btn-create-modal" class="btn-primary-2">Rechazar</button>
      </ion-col>
      <!-- <ion-col size="12" class="center">
        <button (click)="closeModal()" shape="round" class="btn-primary btn-close">Cerrar</button>
      </ion-col> -->
    </ion-row>
  </ion-grid>
  <ion-grid class="form-data" *ngIf="country==='es_Pa'">
    <ion-row>
      <ion-col size="12">
        <section>
          <ion-label class="doc-content">
            En cumplimiento con las leyes de Protección de Datos Personales y nuestras políticas internas aplicables, le
            comunicamos que los datos que Usted nos entregue relacionados con el alcance del Programa de diagnóstico
            para la región del Cono Sur (el “Programa”) quedarán incorporados en nuestras bases de datos, cuyos
            responsables del tratamiento es la empresa Tudo Bem Tudo Bom Andean SAS, (en adelante “TBTB”). Por medio de
            la aceptación del presente documento, Usted en calidad de titular estará autorizando de manera previa,
            expresa, libre e informada a TBTB y sus entidades vinculadas para que como operador logístico del Programa,
            recolecte y dé tratamiento de sus datos personales tales como nombre completo, correo electrónico,
            direcciones, números telefónicos, profesión, especialidad y registro o matrícula profesional según
            corresponda. De igual manera, entiende que según el servicio o apoyo requerido a través del programa,
            especialmente aquellos relacionados con la solicitud de toma de muestras o realización de pruebas a
            pacientes para el diagnóstico o seguimiento de patologías específicas, deberá suministrar los datos
            personales o sensible que como mínimo sean requeridos para la gestión de los servicios solicitados a través
            del programa y que es su responsabilidad haber informado de manera previa al tercero, para que
            posteriormente sea contactado por TBTB o sus entidades vinculadas para la coordinación de dichos servicios.
            (tanto los datos sensibles como los no sensibles en adelante se denominarán los “Datos”). Los Datos serán
            recolectados, almacenados, usados, compilados, intercambiados e incorporados en distintas bases de datos o
            en depósitos electrónicos con las siguientes finalidades: a) Gestionar las solicitudes de toma y análisis de
            pruebas diagnósticas, confirmatorias y/o de seguimiento a pacientes hechas por un médico especialista según
            criterio profesional; b) Compartir con proveedores y/o terceros autorizados, la información específica y
            necesaria para la coordinación y realización de la toma, transporte y análisis de las muestras; c) Remitirle
            los resultados de exámenes médicos; d) Gestionar el retiro de muestras y/o envío de materiales (kits de
            diagnóstico) para la toma de muestras. De igual manera le informamos que dichos servicios están siendo
            patrocinados por Sanofi S.A, quienes bajo ninguna circunstancia tendrán acceso a los Datos que usted decida
            suministrar a TBTB, único responsable del tratamiento. Usted declara que la información personal que
            suministra es veraz, completa, exacta, actualizada, comprobable y comprensible y que ha sido informado de su
            derecho a negarse a responder preguntas de carácter sensible, así como de su derecho a conocer, rectificar,
            incluir, actualizar y solicitar la supresión de su información personal en cualquier momento y sin perjuicio
            alguno, enviando una solicitud al siguiente correo:
            <a target="_blank" href="mailto:contactenos&#64;tbtbglobal.com">contactenos&#64;tbtbglobal.com</a>. Igualmente ha sido informado de su derecho a elevar consultas o preguntas sobre los datos personales que
            están siendo tratados o interponer quejas que serán tratadas de acuerdo con el procedimiento establecido por
            las autoridades competentes de su país. También puede consultar la política de privacidad de datos de Tudo
            Bem Tudo Bom Andean SAS, disponible en el siguiente enlace
            <a target="_blank" href="https://tbtb.global/politicas-privacidad/"
              >https://tbtb.global/politicas-privacidad/</a
            >
            <section>
              <ion-label class="doc-content">
                Ley de Protección de los Datos Personales: Argentina: Ley 25.326; _Paraguay: Ley 1682/01; _Chile: Ley
                21.096.
              </ion-label>
            </section>
            
          </ion-label>
        </section>
      </ion-col>
      <ion-col size="12" class="center" *ngIf="!id">
        <button (click)="closeModal()" shape="round" class="btn-primary btn-close">Cerrar</button>
      </ion-col>
      <ion-col class="ion-text-center" size="12" *ngIf="id">
        <button (click)="submit()" id="btn-edit-modal" class="btn-primary btn-close">Aceptar</button>
      </ion-col>
      <ion-col class="ion-text-center" size="12" *ngIf="id">
        <button (click)="openAlert()" id="btn-create-modal" class="btn-primary-2">Rechazar</button>
      </ion-col>
      <!-- <ion-col size="12" class="center">
        <button (click)="closeModal()" shape="round" class="btn-primary btn-close">Cerrar</button>
      </ion-col> -->
    </ion-row>
  </ion-grid>
</ion-content>

